export const workings = {
    // 主页
    "workings_time": "工时",
    "workings_time_none_title": "无标题",
    "workings_time_manager_title": "管理",
    "workings_time_manager_desc": "进入管理界面",
    "workings_time_manager_fill_in": "进入",
    "workings_time_fill_in": "点击填写",
    "workings_time_view": "查看",
    // 管理
    "workings_manager_title": "工时管理",
    "workings_manager_timesheet_label": "工时单",
    "workings_manager_timesheet_placeholder": "查找工时单",
    "workings_manager_timesheet_opt_all": "全部",
    "workings_manager_timesheet_label_StaffName": "备注名",
    "workings_manager_export": "导出",
    "workings_manager_table_col_SubmitTime": "提交时间",
    "workings_manager_table_col_Timesheet": "工时单",
    "workings_manager_table_col_User": "教师",
    "workings_manager_table_col_StaffName": "备注名",
    "workings_manager_table_col_Option": "操作",
    "workings_manager_table_col_Option_View": "查看详情",
    // 加载状态提示
    "workings_loading": "加载中...",
    // 表单字段：选择周期
    "workings_select_period_label": "选择周期",
    "workings_select_period_placeholder": "请选择一个时间段",
    "workings_select_period_required": "请选择一个时间段",
    // 分隔标题
    "workings_questions_section_title": "问题",
    // 提交成功结果页
    "workings_submit_success_title": "提交成功！",
    "workings_submit_success_subtitle": "如需修改或删除，请前往首页进行操作",
    "workings_return_to_continue_button": "返回继续填写其他工时",
    // 消息提示（来自 useEffect 中的警告）
    "workings_timesheet_not_started": "该工时表尚未开始",
    "workings_no_auth_access_form": "无权访问此表单",
    // 提交成功通知
    "workings_create_success_message": "工时记录创建成功",
};
